import { useSelector } from 'react-redux';
import { RootState } from '../store/store';
import { isAdminReduxRole } from '../services/api';

export const usePermissions = () => {
  const user = useSelector((state: RootState) => state.auth.user);

  const isAdmin = isAdminReduxRole(user?.roles);
  const isViewer = !isAdmin;

  return {
    isAdmin,
    isViewer,
    // Add specific permissions
    canManageSensors: isAdmin,
    canManageBaseUnits: isAdmin,
    canManageZones: isAdmin,
    canManageUsers: isAdmin,
    canEditSettings: isAdmin,
    // Add more permissions as needed
  };
}; 